// extracted by mini-css-extract-plugin
module.exports = {"coverVideo":"CoverVideo_coverVideo__RyXv9","coverVideo__video":"CoverVideo_coverVideo__video__a74g3","ready":"CoverVideo_ready__9l0Mh"};